<template>
  <div>
    <div class="container">
      <section class="my-5 header-section">
        <!--
        <iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2FMawKunInternationalEducationGroupMyanmar%2Fvideos%2F598774699276527%2F&show_text=true&width=560&t=0" width="560" height="429" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" ></iframe>

        <div v-html="testframe" data-show-text="true"></div>
        -->
        <div>
          <div
            class="d-flex flex-column flex-md-row align-items-center justify-content-center g-3"
          >
            <img
              src="./../assets/img/about-us.jpg"
              class="w-100 header-section-img"
              alt=""
            />
            <template v-if="font_type == 1">
              <div class="p-4 header-section-content">
                <h1 class="mb-5" style="font-size: 30px; color: goldenrod">
                  ABOUT SHWE MAW KUN
                </h1>
                <p style="text-align: justify">
                  Established in January 2015, Shwe Maw Kun Private School, part
                  of Maw Kun International Education Group, is one of Myanmar's
                  pioneering English–Myanmar bilingual schools. Registered with
                  the Ministry of Education, Myanmar, the school is committed to
                  providing high-quality, accessible, and affordable bilingual
                  education through a distinctive dual-curriculum pathway that
                  integrates the Myanmar National Curriculum with
                  internationally recognised programmes.
                </p>
                <p style="text-align: justify">
                  Shwe Maw Kun offers a comprehensive educational pathway from
                  Premium Pre-School (Early Years) to Primary and Secondary
                  Education, enriched by Cambridge English, Pearson Edexcel
                  (UK), Singapore Mathematics, Coding, foreign language studies,
                  character education, leadership development, mindfulness,
                  entrepreneurship, and a wide range of co-curricular and
                  extracurricular programmes. Through a safe, stimulating, and
                  nurturing learning environment, the school develops
                  confidence, competence, and character, empowering every
                  learner to become an ethical, compassionate, and socially
                  responsible global citizen.
                </p>
                <p style="text-align: justify">
                  Through various initiatives such as co-curricular and
                  extracurricular activities, enrichment programmes, the Weekend
                  International Programme and community engagement projects, the
                  school aims to foster holistic growth, leadership, and
                  lifelong well-being in every pupil. A strong emphasis on
                  physical education and healthy lifestyles further supports
                  pupils' physical, social, and emotional development.
                  Furthermore, as a trusted British Council Partner, Shwe Maw
                  Kun stands as a premier institution in the region, providing
                  Pearson Edexcel qualifications, including the Early Years
                  Centre, Cambridge English Exam Preparation Centre, and Leader
                  in Me (LiM) School, ensuring adherence to globally recognised
                  standard of teaching and learning with affordable tuition fees
                  to provide internationally recognised educational
                  opportunities.
                </p>
              </div>
            </template>
            <template v-if="font_type == 2">
              <div class="p-4 header-section-content">
                <h1
                  class="mb-5"
                  style="font-size: 30px; line-height: 48px; color: goldenrod"
                >
                  ရွှေမော်ကွန်း ကျောင်းအကြောင်း
                </h1>
                <p style="text-align: justify; line-height: 30px">
                  ၂၀၁၅ ခုနှစ်၊ ဇန်နဝါရီလတွင် စတင်တည်ထောင်ခဲ့သော Maw Kun
                  International Education Group ၏ ရွှေမော်ကွန်း
                  ကိုယ်ပိုင်ကျောင်း သည် မြန်မာနိုင်ငံတွင် မြန်မာ၊
                  အင်္ဂလိပ်ဘာသာစကားနှစ်မျိုးဖြင့် ဘက်စုံပညာရေး ကို
                  ဖော်ဆောင်ပေးနေသော ကျောင်းများအနက် တစ်ကျောင်းအပါအဝင် ဖြစ်ပါသည်။
                  မြန်မာနိုင်ငံ ပညာရေးဝန်ကြီးဌာနတွင် မှတ်ပုံတင်ထားပြီး
                  မြန်မာအမျိုးသားသင်ရိုးညွှန်းတမ်း အပြင် ထပ်ဆောင်းဘာသာရပ်များကို
                  သင့်တင့်သည့် ကျောင်းလခနှုန်းထားဖြင့် မြန်မာ၊
                  အင်္ဂလိပ်ဘာသာစကားနှစ်မျိုးဖြင့် သင်ကြားပေးပါသည်။
                </p>
                <p style="text-align: justify; line-height: 30px">
                  ရွှေမော်ကွန်းကျောင်းသည် အဆင့်မြင့်မူကြိုပညာရေး (Early Years)
                  မှစ၍ မူလတန်း၊ အလယ်တန်းနှင့် အထက်တန်းပညာရေးအထိ စနစ်တကျ
                  ဆက်လက်သင်ယူနိုင်သည့် ပညာရေးလမ်းကြောင်းကို
                  ဖော်ဆောင်လျက်ရှိပါသည်။ ရွှေမော်ကွန်းကျောင်းတွင် Cambridge
                  English၊ Pearson Edexcel (UK)၊ Singapore Mathematics နှင့်
                  Coding တို့အပြင် နိုင်ငံခြားဘာသာစကားများ၊
                  ခေါင်းဆောင်မှုဖွံ့ဖြိုးရေး (Leadership Development)၊
                  စာရိတ္တမြင့်တင်ပညာရေး (Character Education)၊ သတိပဋ္ဌာန်နှင့်
                  စိတ်တည်ငြိမ်မှု (Mindfulness)၊ စွန့်ဦးတီထွင်မှုနှင့်
                  စီးပွားရေးစွမ်းဆောင်ရည် ဖွံ့ဖြိုးရေး (Entrepreneurship)
                  တို့ကိုလည်း
                  ထည့်သွင်းသင်ကြားပေးပါသည်။ထိုသို့သင်ကြားသင်ယူခြင်းဖြင့်
                  ကိုယ်ကျင့်တရားကောင်းမွန်ပြီး အခြားသူများအပေါ် စာနာနားလည်တတ် ကာ
                  လူမှုအသိုင်းအဝိုင်းအပေါ် တာဝန်ယူတတ်သော
                  ကမ္ဘာ့နိုင်ငံသားကောင်းများ ဖြစ်လာစေရန်လည်း
                  အလေးအနက်ထားသင်ကြားပေးလျက် ရှိပါသည်။
                </p>
                <p style="text-align: justify; line-height: 30px">
                  ကျောင်းသား၊ ကျောင်းသူများ၏ ဘက်စုံဖွံ့ဖြိုးတိုးတက်မှု၊
                  ခေါင်းဆောင်မှုစွမ်းရည်ကို ဖော်ဆောင်ပေးနိုင်ရန်အတွက် ကျောင်းမှ
                  ထပ်ဆောင်းဘာသာရပ်များ၊ ရွှေမော်ကွန်းကိုယ်ပိုင်ကျောင်း တွင်
                  ပြင်ပကျောင်းသား၊ကျောင်းသူများအတွက် စနေ၊ တနင်္ဂနွေ
                  တန်းခွဲများနှင့် လူထုအကျိုးပြု လှုပ်ရှားမှုများ စသည့်
                  အစီအစဉ်အမျိုးမျိုးကို စနစ်တကျ စီစဉ်ဆောင်ရွက်ပေးလျက် ရှိပါသည်။
                  ထို့ပြင် ကာယပညာနှင့် ကျန်းမာရေးဆိုင်ရာ နေထိုင်မှုပုံစံများကို
                  အထူးဦးစားပေး လေ့ကျင့်ပေးခြင်းဖြင့် ကျောင်းသား၊ကျောင်းသူများ၏
                  လူမှုဆက်ဆံရေးနှင့် စိတ်ဓာတ်ပိုင်းဆိုင်ရာ
                  ဖွံ့ဖြိုးတိုးတက်မှုများကိုပါ အထောက်အကူပြုပေးပါသည်။
                </p>
                <p style="text-align: justify; line-height: 30px">
                  ထို့အပြင် British Council Partner ကျောင်း တစ်ခုအဖြစ်
                  ရွှေမော်ကွန်းကျောင်းသည် အရည်အသွေးမြင့် ပညာရေးကို
                  ပေးအပ်လျက်ရှိပြီး Pearson Edexcel (UK) နိုင်ငံတကာ
                  စာမေးပွဲစင်တာ အပါအဝင် Early Years Centre တစ်ခုအဖြစ်လည်းကောင်း၊
                  Cambridge English စာမေးပွဲ လေ့ကျင့်ပြင်ဆင်ပေးသည့်
                  စင်တာအဖြစ်လည်းကောင်း၊ Leader in Me (LiM) သင်ကြားရေးကျောင်း
                  အဖြစ်လည်းကောင်း ရပ်တည်လျက်ရှိပါသည်။
                </p>

                <p style="text-align: justify; line-height: 30px">
                  ထိုသို့ နိုင်ငံတကာအသိအမှတ်ပြု
                  သင်ကြားသင်ယူမှုစံနှုန်းများနှင့်အညီ ဆောင်ရွက်ပေးခြင်းအားဖြင့်
                  ကျောင်းသား၊ ကျောင်းသူများအတွက် နိုင်ငံတကာအသိအမှတ်ပြု
                  ပညာရေးအခွင့်အလမ်းများကို သင့်တင့်သည့်ကျောင်းလခနှုန်းထားဖြင့်
                  ရရှိနိုင်စေရန် အလေးထားဆောင်ရွက်လျက်ရှိပါသည်။
                </p>
              </div>
            </template>
          </div>
        </div>
      </section>

      <section class="smk_responsive mb-5">
        <div class="row gx-0 gy-3 gy-sm-0">
          <div
            class="col shadow"
            style="border: 0px; border-right: 2px black; border-style: solid"
          >
            <div
              v-if="font_type == 1"
              class="section2_divleft"
              style="white-space: pre-wrap"
            >
              <h3 class="text-center" style="white-space: nowrap">
                Educational Excellence
              </h3>
              <ul style="text-align: left">
                <li>
                  To become a nationally and internationally-recognised school
                  providing quality and affordable bilingual education to pupils
                  to develop confidence, competence, and character, and to
                  prepare each pupil for a socially responsible and
                  compassionate citizen.
                </li>
                <br />
                <li>
                  We actively champion and nurture gifted individuals who
                  exhibit exceptional abilities, immense potential, and
                  remarkable leadership qualities, empowering them to make
                  significant contributions to the educational progress and
                  overall advancement of our nation.
                </li>
              </ul>
            </div>
            <div v-if="font_type == 2" class="section2_divleft">
              <h3 class="mb-5">ပညာရေး မျှော်မှန်းချက်</h3>
              <ul style="list-style-type: square; text-align: left">
                <li>
                  <p>
                    ကျောင်းသား၊ ကျောင်းသူများ၏ ယုံကြည်မှု၊ စွမ်းဆောင်ရည်နှင့်
                    ကိုယ်ကျင့်တရားကောင်းမွန်မှုတို့ကို ဖွံ့ဖြိုးတိုးတက်စေရန်
                    နှင့် လူမှုအဖွဲ့အစည်းအပေါ် တာဝန်ယူတတ်ပြီး ကရုဏာတရားရှိသော
                    နိုင်ငံသားကောင်းများအဖြစ် ပြုစုပျိုးထောင်ပေးနိုင်ရန်
                    ရည်ရွယ်ပါသည်။
                  </p>
                </li>
                <br />
                <li>
                  <p>
                    ကျောင်းသား၊ ကျောင်းသူများအတွက် အရည်အသွေးပြည့်ဝ သည့်
                    အမျိုးသားအဆင့်နှင့် နိုင်ငံတကာအဆင့် အသိအမှတ်ပြု ဘက်စုံ
                    ပညာရေးကို သင့်တင့်သည့် ကျောင်းလခဖြင့် သင်ယူနိုင်ရန်
                    ရည်ရွယ်ပါသည်။
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="col shadow"
            style="border: 0px; border-right: 2px black; border-style: solid"
          >
            <div v-if="font_type == 1" class="section2_divcenter">
              <h3 class="text-center" style="white-space: nowrap">
                Educational Purpose
              </h3>
              <ul style="text-align: left">
                <li>
                  To provide the best possible high-quality, accessible, and
                  affordable bilingual education through a holistic learning
                  experience that integrates nationally and internationally
                  recognised curricula, empowering every pupil to achieve
                  academic excellence and realise their full potential.
                </li>
                <br />
                <li>
                  To nurture confident, competent, and compassionate learners by
                  fostering critical thinking, creativity, leadership,
                  character, social-emotional well-being, and lifelong learning
                  in a safe, stimulating, and inclusive environment.
                </li>
                <br />
                <li>
                  To develop ethical, socially responsible, and globally minded
                  citizens equipped with the knowledge, skills, values, and
                  resilience to contribute positively to their communities and
                  create a happier, brighter, and more sustainable future.
                </li>
                <br />
              </ul>
            </div>
            <div v-if="font_type == 2" class="section2_divcenter">
              <h3 class="mb-5" style="white-space: nowrap">
                ပညာရေးဆိုင်ရာ ရည်ရွယ်ချက်
              </h3>
              <ul style="list-style-type: square; text-align: start">
                <li>
                  <p>
                    အမျိုးသားအဆင့်နှင့် နိုင်ငံတကာအဆင့် အသိအမှတ်ပြု
                    သင်ရိုးညွှန်းတမ်းများကို ပေါင်းစပ်ထားသည့်
                    သင်ယူမှုအတွေ့အကြုံမှတစ်ဆင့် အရည်အသွေးမြင့်မားပြီး
                    သင့်တင့်သည့် ကျောင်းလခနှုန်းထား ဖြင့် ပညာသင်ယူနိုင်ပြီး
                    ကာယ၊ဉာဏ စွမ်းရည် များကို အပြည့်အဝကို ဖော်ထုတ်ပေးနိုင်ရန်
                    ရည်ရွယ်ပါသည်။
                  </p>
                </li>
                <li>
                  <p>
                    စူးစမ်းသင်ယူလိုစိတ်ကို မြှင့်တင်ပေးပြီးအားလုံးပါဝင်နိုင်သည့်
                    သင်ယူမှုပတ်ဝန်းကျင် တွင် ဝေဖန်ပိုင်းခြားတွေးခေါ်နိုင်စွမ်း၊
                    တီထွင်ဖန်တီးနိုင်စွမ်း၊ ခေါင်းဆောင်မှု၊ ကိုယ်ကျင့်တရား၊
                    လူမှုဆက်ဆံရေးနှင့် စိတ်ပိုင်းဆိုင်ရာကောင်းမွန်မှုများကို
                    ပြုစုပျိုးထောင်ပေးပြီး သင်ယူလိုစိတ်ကိုလည်း မြင့်မားပြီး
                    ကရုဏာတရားပြည့်ဝသော ကျောင်းသား၊ ကျောင်းသူများ ဖြစ်လာစေရန်
                    ရည်ရွယ်ပါသည်။
                  </p>
                </li>
                <li>
                  <p>
                    ကိုယ်ကျင့်တရားကောင်းမွန်ပြီး လူမှုအသိုင်းအဝိုင်းအပေါ်
                    တာဝန်ယူတတ်သော နိုင်ငံသားကောင်းများ ဖြစ်လာစေရန်။
                  </p>
                </li>
                <li>
                  <p>
                    ပြဿနာများ ရင်ဆိုင်ဖြေရှင်းနိုင်စွမ်းတို့ကို
                    ပျိုးထောင်ပေးပြီး မိမိတို့၏ လူမှုအသိုင်းအဝိုင်းအတွက်
                    အပြုသဘောဆောင်သော နိုင်ငံသားကောင်းများပေါ်ထွန်းလာစေရန်
                    ရည်ရွယ်ပါသည်။
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col shadow" style="">
            <div v-if="font_type == 1" class="section2_divright">
              <h3 class="text-center" style="white-space: nowrap">
                Educational Academic System
              </h3>
              <ul style="text-align: left">
                <li>
                  Establish and advance a high-quality bilingual academic system
                  through a collaborative approach with national and
                  international educational institutions, integrating the
                  Myanmar National Curriculum with internationally recognised
                  programmes. By embracing two fundamental pillars of
                  exceptional education, the school provides diverse learning
                  pathways, promotes equal opportunities, and cultivates a
                  culture of excellence.
                </li>
                <br />
                <li>
                  Promote excellence in teaching and learning by continuously
                  enhancing teaching methodologies, implementing robust
                  professional development programmes, and fostering innovation,
                  collaboration, and educational excellence among educators,
                  while strengthening educational standards within both local
                  and global contexts.
                </li>
                <br />
                <li>
                  Facilitate the acquisition and wide dissemination of
                  knowledge, skills, and values through a holistic bilingual
                  curriculum that develops academic excellence, critical
                  thinking, creativity, digital literacy, leadership, character,
                  and lifelong learning within a safe, stimulating, and
                  inclusive learning environment.
                </li>
                <br />
                <li>
                  Nurture exceptional talent and innovation by creating a
                  stimulating academic environment that encourages creativity,
                  research, academic competitions, entrepreneurship, enrichment
                  programmes, co-curricular and extracurricular activities, and
                  meaningful community engagement, enabling every pupil to
                  realise their full potential.
                </li>
                <br />
                <li>
                  Develop ethical, socially responsible, and globally minded
                  citizens by cultivating confidence, competence, and character,
                  while promoting a culture of responsibility, resilience, and
                  exemplary leadership. The school empowers every pupil to
                  contribute positively to their communities and create a
                  happier, brighter, and more sustainable future in the 21ˢᵗ
                  century.
                </li>
              </ul>
            </div>
            <div v-if="font_type == 2" class="section2_divright">
              <h3 class="mb-5">အနာဂတ် ပညာရေးပန်းတိုင်</h3>
              <ul style="list-style-type: square; text-align: start">
                <li>
                  <p>
                    အရည်အသွေးမြင့် ဘက်စုံပညာရေး စနစ်ကို ဖော်ဆောင်ရန် -
                    ပြည်တွင်းနှင့် နိုင်ငံတကာ ပညာရေးအဖွဲ့အစည်းများနှင့်
                    ပူးပေါင်းဆောင်ရွက်၍ မြန်မာအမျိုးသားသင်ရိုးညွှန်းတမ်းနှင့်
                    နိုင်ငံတကာအသိအမှတ်ပြု ပညာရေးအစီအစဉ်များကို ပေါင်းစပ်ထားသည့်
                    အရည်အသွေးမြင့် ပညာရေးစနစ်ကို စနစ်တကျ တည်ဆောက်ရန်။
                  </p>
                </li>
                <li>
                  <p>
                    အရည်အသွေးမြင့်မားသော ပညာရေး၏ အခြေခံအချက်များကို
                    အလေးထားဆောင်ရွက်ခြင်းဖြင့် ကျောင်းသား၊ ကျောင်းသူများအတွက်
                    မတူညီသော သင်ယူမှုလမ်းကြောင်းများနှင့် တန်းတူညီမျှသော
                    သင်ယူခွင့်များကို ဖော်ဆောင် ပေးကာ ထူးချွန်မှုကို အားပေးသည့်
                    သင်ယူမှုယဉ်ကျေးမှုတစ်ရပ်ကို တည်ဆောက်ရန်။
                  </p>
                </li>
                <li>
                  <p>
                    သင်ကြားရေးနှင့် သင်ယူမှု စံနှုန်းများကို မြှင့်တင်ရန် -
                    သင်ကြားရေးနှင့် သင်ယူရေးတွင် ထူးချွန်မှုရရှိစေရန်
                    သင်ကြားနည်းများကို စဉ်ဆက်မပြတ် မြှင့်တင်ပေးခြင်း၊ ဆရာ၊
                    ဆရာမများ၏ ပညာရပ်ဆိုင်ရာ ဖွံ့ဖြိုးတိုးတက်မှုအတွက် ထိရောက်သော
                    အစီအစဉ်များကို အကောင်အထည်ဖော်ခြင်းနှင့် ဆန်းသစ်တီထွင်မှု၊
                    ပူးပေါင်းဆောင်ရွက်မှုနှင့် ထူးချွန်မှုကို အားပေးသည့်
                    သင်ကြားရေးယဉ်ကျေးမှုကို ပျိုးထောင်ခြင်းတို့မှတစ်ဆင့်
                    ပြည်တွင်းနှင့် နိုင်ငံတကာအဆင့်တွင် ပညာရေးစံနှုန်းများကို
                    ပိုမိုမြှင့်တင်ရန်။
                  </p>
                </li>
                <li>
                  <p>
                    ဘက်စုံပညာရေး မှတစ်ဆင့် အသိပညာနှင့် ကျွမ်းကျင်မှုများကို
                    မျှဝေရန် - လုံခြုံစိတ်ချရပြီး စူးစမ်းလေ့လာလိုစိတ်ကို
                    နိုးဆွပေးကာ အားလုံးပါဝင်နိုင်သည့် သင်ယူမှုပတ်ဝန်းကျင်တွင်
                    ပညာရပ်ဆိုင်ရာ ထူးချွန်မှု၊
                    ဝေဖန်ပိုင်းခြားတွေးခေါ်နိုင်စွမ်း၊ တီထွင်ဖန်တီးနိုင်စွမ်း၊
                    ဒစ်ဂျစ်တယ်နည်းပညာအသုံးချနိုင်စွမ်း၊ ခေါင်းဆောင်မှု၊
                    ကိုယ်ကျင့်တရားကောင်းမွန်မှုနှင့် လေ့လာသင်ယူမှုတို့ကို
                    ပျိုးထောင်ပေးသည့် ဘက်စုံ ပညာရေး မှတစ်ဆင့် အသိပညာများ
                    ရရှိစေရန်။
                  </p>
                </li>
                <li>
                  <p>
                    ထူးချွန်သောစွမ်းရည်များနှင့် အလားအလာများကို
                    အပြည့်အဝပြုစုပျိုးထောင်ပေးရန် - စူးစမ်းလေ့လာလိုစိတ်နှင့်
                    တီထွင်ဖန်တီးနိုင်စွမ်းကို အားပေးသည့်
                    ပညာရေးပတ်ဝန်းကျင်မှတစ်ဆင့် ထူးချွန်သော စွမ်းရည်များနှင့်
                    ဆန်းသစ်တီထွင်မှုများကို ပျိုးထောင်ကာ သုတေသန၊ ပညာရပ်ဆိုင်ရာ
                    ပြိုင်ပွဲများ၊ စွန့်ဦးတီထွင်မှု၊
                    တိုးချဲ့သင်ယူမှုအစီအစဉ်များ၊ လူမှုအသိုင်းအဝိုင်းနှင့်
                    ပူးပေါင်းဆောင်ရွက်မှုများမှတစ်ဆင့် ကျောင်းသား၊
                    ကျောင်းသူတိုင်း မိမိတို့၏ စွမ်းရည်များကို အပြည့်အဝ
                    ဖော်ထုတ်နိုင်စေရန်။
                  </p>
                </li>
                <li>
                  <p>
                    ကျင့်ဝတ်ကောင်းမွန်ကာ လူမှုအသိုင်းအဝိုင်းအပေါ် တာဝန်ယူတတ်ပြီး
                    ကမ္ဘာ့နိုင်ငံသားကောင်းများ ဖြစ်လာစေရန် - ကျောင်းသား၊
                    ကျောင်းသူများ၏ မိမိကိုယ်ကို
                    ယုံကြည်မှု၊ကိုယ်ကျင့်တရားကောင်းမွန်မှုတို့ကို ပျိုးထောင်ကာ
                    တာဝန်ယူမှု၊ စံနမူနာပြ ခေါင်းဆောင်မှုတို့ကို အားပေးသည့်
                    ယဉ်ကျေးမှုတစ်ရပ်ကို ဖော်ဆောင်ပြီး ကျင့်ဝတ်ကောင်းမွန်ကာ
                    လူမှုအသိုင်းအဝိုင်းအပေါ် တာဝန်ယူတတ်သော
                    ကမ္ဘာ့နိုင်ငံသားကောင်းများ ဖြစ်လာစေရန်။
                  </p>
                  <p>
                    ထိုမှတစ်ဆင့် ၂၁ ရာစုတွင် မိမိတို့၏ လူမှုအသိုင်းအဝိုင်းအတွက်
                    အကျိုးပြုပြီး တောက်ပသော အနာဂတ်ကို ဖန်တီးပုံဖော်နိုင်စေရန်
                    ရည်ရွယ်ပါသည်။
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <!-- Mission & Vision -->
      <section class="mt-5 mb-5">
        <div class="container">
          <template v-if="font_type == 1">
            <h2
              class="text-center mb-5"
              style="color: goldenrod; font-weight: 900"
            >
              Mission & Vision
            </h2>
            <div class="row gx-lg-5">
              <div class="col-lg-6">
                <h3 class="mb-4" style="color: purple; font-weight: 900">
                  Mission
                </h3>
                <p style="text-align: justify">
                  To empower a diverse pupil body through an affordable,
                  globally recognized bilingual education within a safe,
                  stimulating environment that nurtures the strength of
                  character and competence needed to thrive as responsible and
                  compassionate global citizens.
                </p>
              </div>
              <div class="col-lg-6">
                <h3 class="mb-4" style="color: purple; font-weight: 900">
                  Vision
                </h3>
                <p style="text-align: justify">
                  To be a leading and accessible bilingual school that empowers
                  every pupil to become ethical, socially responsible, and
                  compassionate global citizens who shape a happier, brighter
                  and more sustainable future.
                </p>
              </div>
            </div>
          </template>
          <template v-if="font_type == 2">
            <h2
              class="text-center mb-5"
              style="color: goldenrod; font-weight: 900"
            >
              Mission & Vision
            </h2>
            <div class="row gx-lg-5">
              <div class="col-lg-6">
                <h3 class="mb-4" style="color: purple; font-weight: 900">
                  Mission - ရည်မှန်းချက်
                </h3>
                <p style="text-align: justify; line-height: 30px">
                  စူးစမ်းလေ့လာလိုစိတ်ကို နိုးဆွပေးသည့် သင်ယူမှုပတ်ဝန်းကျင်တွင်
                  အမျိုးသားအဆင့်နှင့် နိုင်ငံတကာအဆင့် အသိအမှတ်ပြု
                  ဘက်စုံပညာရေးမှတစ်ဆင့် မတူကွဲပြားသော ကျောင်းသား၊
                  ကျောင်းသူတိုင်း၏ စွမ်းရည်များကို မြှင့်တင်ပေးကာ တာဝန်ယူတတ်ပြီး
                  ကရုဏာတရားပြည့်ဝသော ကမ္ဘာ့နိုင်ငံသားကောင်းများအဖြစ်
                  ရပ်တည်နိုင်ရန် လိုအပ်သည့် ကိုယ်ကျင့်တရားကောင်းမွန်မှုနှင့်
                  စွမ်းဆောင်ရည်တို့ကို ပြုစုပျိုးထောင်ပေးရန် ရည်မှန်းပါသည်။
                </p>
              </div>
              <div class="col-lg-6">
                <h3 class="mb-4" style="color: purple; font-weight: 900">
                  Vision - မျှော်မှန်းချက်
                </h3>
                <p style="text-align: justify; line-height: 30px">
                  အရည်အသွေးမြင့်မားသော မြန်မာ၊ အင်္ဂလိပ်ဘာသာစကားနှစ်မျိုးဖြင့်
                  ဘက်စုံပညာရေးတွင် ဦးဆောင်သည့် ကျောင်းတစ်ကျောင်း အဖြစ် ရပ်တည်ကာ
                  ကျောင်းသား၊ ကျောင်းသူတိုင်းကို ကျင့်ဝတ်ကောင်းမွန်ပြီး
                  လူမှုအသိုင်းအဝိုင်းအပေါ် တာဝန်ယူတတ်ကာ ကရုဏာတရားပြည့်ဝသော
                  ကမ္ဘာ့နိုင်ငံသားများအဖြစ် ပျိုးထောင်ပေးပြီး တောက်ပို့သော
                  အနာဂတ်ကို ဖန်တီးပုံဖော်နိုင်စေရန် မျှော်မှန်းပါသည်။
                </p>
              </div>
            </div>
          </template>
        </div>
      </section>

      <section style="background-color: purple">
        <section class="">
          <ul class="tabs-controls">
            <li class="tabs-controls__item">
              <a
                href="#"
                class="tabs-controls__link tabs-controls__link--active"
                data-id="1"
              >
                T
              </a>
            </li>
            <li class="tabs-controls__item">
              <a href="#" class="tabs-controls__link" data-id="2"> R </a>
            </li>
            <li class="tabs-controls__item">
              <a href="#" class="tabs-controls__link" data-id="3"> U </a>
            </li>
            <li class="tabs-controls__item">
              <a href="#" class="tabs-controls__link" data-id="4"> S </a>
            </li>
            <li class="tabs-controls__item">
              <a href="#" class="tabs-controls__link" data-id="5"> T </a>
            </li>
          </ul>
        </section>
        <section class="cards-container smk_responsive2">
          <!--    Teach-->
          <div v-if="font_type == 1" class="card card--current" id="1">
            <h1><span style="color: purple">T</span>EAMWORK</h1>
            <p style="font-size: 20px">
              <br />
              A culture of teamwork built on mutual respect, shared
              responsibility, accountability, and a commitment to achieve
              excellence together.
            </p>
          </div>
          <div v-if="font_type == 2" class="card card--current" id="1">
            <h1>
              <span style="color: purple">T</span> - Teach - သင်ကြားသင်ယူမှု
            </h1>
            <p style="font-size: 20px">
              <br />
              အပြန်အလှန်လေးစားမှု၊ မျှဝေထားသော တာဝန်ယူမှု၊ တာဝန်ခံမှုတို့ကို
              အခြေခံ၍ အတူတကွ ထူးချွန်အောင်မြင်မှုရရှိရန် ကြိုးပမ်းသည့်
              ပူးပေါင်းဆောင်ရွက်မှု ယဉ်ကျေးမှုကို ဖော်ဆောင်ခြင်း။
            </p>
          </div>

          <!--    Respect-->
          <div v-if="font_type == 1" class="card" id="2">
            <h1><span style="color: purple">R</span>ESPECT</h1>
            <p style="font-size: 20px">
              <br />
              Demonstrating respect for self, others, and the environment
              through responsible words and actions.
            </p>
          </div>
          <div v-if="font_type == 2" class="card" id="2">
            <h1><span style="color: purple">R</span> - Respect</h1>
            <p style="font-size: 20px">
              <br />
              မိမိကိုယ်ကို၊ အခြားသူများနှင့် ပတ်ဝန်းကျင်ကို လေးစားတန်ဖိုးထားပြီး
              တာဝန်ယူမှုရှိသော စကားများနှင့် လုပ်ရပ်များဖြင့်
              လက်တွေ့ဖော်ပြခြင်း။
            </p>
          </div>

          <!--    unique-->
          <div v-if="font_type == 1" class="card" id="3">
            <h1><span style="color: purple">U</span>NIQUE</h1>
            <p style="font-size: 20px">
              <br />
              A unique integrated bilingual education and dual-curriculum
              pathway that cultivates academic excellence, character, and global
              citizenship.
            </p>
          </div>
          <div v-if="font_type == 2" class="card" id="3">
            <h1><span style="color: purple">U</span> - Unique</h1>
            <p style="font-size: 20px">
              <br />
              ပညာရပ်ဆိုင်ရာ ထူးချွန်မှု၊ ကိုယ်ကျင့်တရားကောင်းမွန်မှုနှင့်
              ကမ္ဘာ့နိုင်ငံသားစိတ်ဓာတ်တို့ကို ဖွံ့ဖြိုးပျိုးထောင်ပေးသည့်
              ထူးခြားသော မြန်မာ–အင်္ဂလိပ် ဘာသာစကားနှစ်မျိုးသုံး ပညာရေးနှင့်
              သင်ရိုးညွှန်းတမ်းနှစ်မျိုး ပေါင်းစပ်ထားသည့် ပညာရေးလမ်းကြောင်းကို
              ဖော်ဆောင်ခြင်း။
            </p>
          </div>
          <!--    Success-->
          <div v-if="font_type == 1" class="card" id="4">
            <h1><span style="color: purple">S</span>UCCESS</h1>
            <p style="font-size: 20px">
              <br />
              A commitment to the continuous growth, achievement, and success of
              every pupil and educator.
            </p>
          </div>
          <div v-if="font_type == 2" class="card" id="4">
            <h1><span style="color: purple">S</span> - Success</h1>
            <p style="font-size: 20px">
              <br />
              ကျောင်းသား၊ ကျောင်းသူနှင့် ဆရာ၊ ဆရာမတစ်ဦးချင်းစီ၏ စဉ်ဆက်မပြတ်
              တိုးတက်မှု၊ အောင်မြင်မှုနှင့် ရလဒ်ကောင်းများ ရရှိစေရန် အစဉ်တစိုက်
              ကြိုးပမ်းခြင်း။
            </p>
          </div>

          <!--    Talent-->
          <div v-if="font_type == 1" class="card" id="5">
            <h1><span style="color: purple">T</span>ALENT & TRUTHFULNESS</h1>
            <p style="font-size: 20px">
              <br />
              A dedication to discovering and nurturing the unique talents,
              skills, and potential of every pupil and educator through honesty,
              integrity, and ethical conduct.
            </p>
          </div>
          <div v-if="font_type == 2" class="card" id="5">
            <h1><span style="color: purple">T</span> - Talent</h1>
            <p style="font-size: 20px">
              <br />
              ကျောင်းသား၊ ကျောင်းသူနှင့် ဆရာ၊ ဆရာမတစ်ဦးချင်းစီ၏ ထူးခြားသော
              အရည်အချင်းများ၊ ကျွမ်းကျင်မှုများနှင့် အလားအလာများကို
              ရှာဖွေဖော်ထုတ်၍ ရိုးသားမှု၊ ဖြောင့်မတ်မှုနှင့်
              ကျင့်ဝတ်ကောင်းမွန်သော အပြုအမူများမှတစ်ဆင့်
              ပြုစုပျိုးထောင်ပေးခြင်း။
            </p>
          </div>
        </section>
      </section>

      <Messages> </Messages>

      <section
        id="examcenter"
        tabindex="0"
        class="mb-5"
        style="width: 100%; height: 100%"
      >
        <div class="shadow p-4">
          <h2 class="m-3"><b>INTERNATIONAL OLYMPIAD EXAM</b></h2>
          <div class="row mb-5 align-items-center">
            <div class="col-6 col-md-4">
              <img src="../assets/img/timo.jpg" class="exam-image" alt="" />
            </div>
            <div class="col-6 col-md-4">
              <img
                src="../assets/img/south_asia_math.jpg"
                class="exam-image"
                alt=""
              />
            </div>
            <div class="col-6 col-md-4">
              <img src="../assets/img/hk_math.jpg" class="exam-image" alt="" />
            </div>
            <div class="col-6 col-md-4">
              <img
                src="../assets/img/hippo2023.jpg"
                class="exam-image"
                slt=""
              />
            </div>
            <div class="col-6 col-md-4">
              <img
                src="../assets/img/hk_science.jpg"
                class="exam-image"
                alt=""
              />
            </div>
            <div class="col-6 col-md-4">
              <img
                src="../assets/img/hk_international_computer.jpg"
                class="exam-image"
                alt=""
              />
            </div>
          </div>
          <!--              <img style="width:100%; height:100%; object-fit: contain;" src="./../assets/img/ourpartner.png" alt="">-->
        </div>
      </section>

      <section id="parter" class="" style="width: 100%; height: 100%">
        <div class="shadow mb-5 p-4">
          <h2 class="m-3"><b>OUR ACCREDITATIONS</b></h2>
          <img
            class="accerditations-image"
            src="./../assets/img/ourpartner2.jpg"
            alt="Our Accreditations"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import MV from "../views/vision_mission.vue";
import Messages from "@/components/About/Messages.vue";
export default {
  data() {
    return {
      testframe:
        "<iframe src='https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FMawKunInternationalEducationGroupMyanmar%2Fposts%2Fpfbid0TictB8kXpSfGdK8C2r2BEJxSMqSYnByY51MZVgwPNFjdx1W5Et1AU4fkoUbLFs6Pl&show_text=true&width=500' width='500' height='500' style='border:none;overflow:hidden' scrolling='yes' frameborder='0' allowfullscreen='true' allow='autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share'></iframe>",
    };
  },
  components: {
    MV,
    Messages,
  },
  computed: {
    font_type() {
      return this.$store.state.font_type;
    },
  },
  mounted() {
    //       $(document).ready(function() {

    // });
    $("#scrolldown").hide();
    $(document).ready(function () {
      $("#scrolldownbtn").click(function () {
        $("#scrolldown").slideToggle("slow", function () {
          // Animation complete.
        });
      });

      var oldId = null;

      $(".tabs-controls__link").click(function (e) {
        e.preventDefault();

        if ($(this).hasClass("tabs-controls__link--active")) {
          return false;
        }

        var currentId = parseInt($(this).data("id"), 10);
        $(".tabs-controls__link--active").removeClass(
          "tabs-controls__link--active",
        );
        $(this).addClass("tabs-controls__link--active");

        if (currentId < oldId) {
          // item is hidden
          var timing = $(".card.hidden").length * 100;
          $(".card").each(function (index) {
            if (index > currentId - 1 || index == currentId - 1) {
              window.setTimeout(function () {
                $(".card").eq(index).removeClass("hidden");
              }, timing - index * 100);
            }
          });
        } else {
          $(".card").each(function (index) {
            if (index < currentId - 1) {
              window.setTimeout(function () {
                $(".card").eq(index).addClass("hidden");
              }, index * 100);
            }
          });
        }

        oldId = currentId;
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.header-section {
  p {
    font-size: 18px;

    @include breakpoint(large) {
      font-size: 20px;
    }
  }
}

.header-section-content p,
.row.gx-lg-5 p {
  text-indent: 2em;
}

.header-section-img {
  width: auto;
  height: 300px;

  @include breakpoint(medium) {
    height: 400px;
    width: 493px !important;
  }
}

.header-section-content {
  width: 100%;

  @include breakpoint(medium) {
    width: 800px;
  }
}

.exam-image {
  width: 100%;

  @include breakpoint(large) {
    width: 300px;
  }
}

.accerditations-image {
  height: 100px;
  object-fit: contain;

  @include breakpoint(large) {
    height: 300px;
  }
}

$itemsCount: 6; // Adjust if tabs number changes
// Fonts
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,700");

h1 {
  margin: 0;
  font-size: 30px;
  line-height: 1;
  color: rgb(0, 0, 0);
}

// Layout
.page {
  width: 100vw;
  height: 60vh;
  min-height: 700px;
  overflow: hidden;
}

// Tabs
.tabs-controls {
  position: relative;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 10px;
  list-style-type: none;

  @include breakpoint(large) {
    padding: 50px 0 100px;
  }
}

.tabs-controls__link {
  position: relative;
  display: block;
  padding: 10px 14px;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  text-transform: uppercase;
  text-decoration: none;

  @include breakpoint(large) {
    padding: 16px 32px;
    font-size: 20px;
  }

  &:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    width: 0;
    height: 4px;
    background-color: #ebebeb;
    border-radius: 2px;
    margin: auto;
    content: "";
    transition: width 0.4s;
  }
}

.tabs-controls__link--active {
  &:after {
    width: 100%;
  }
}

.cards-container {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 400px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.card {
  position: absolute;
  width: 80%;
  height: 300px;
  background-color: gold;
  border: 1px solid #423e37;
  box-shadow: 9px 11px 3px 0px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 40px;
  transition: transform 0.3s, opacity 0.2s;

  &.hidden {
    z-index: 100;
    background-color: #fff;
    color: #fff;
    opacity: 0;
    transition: color 0.5s, background-color 0.5s, transform 1s,
      opacity 0.2s 0.4s;

    h1 {
      color: #fff;
      transition: color 0.5s;
    }

    @for $i from 1 through $itemsCount {
      &:nth-of-type(#{$i}) {
        transform: rotate(random(100) - 100 + deg)
          translateX((random(1) + 100) * 1%)
          translateY(random(60) * -1%)
          scale(random(10) * 0.1)
          skewX(random(12) + deg)
          skewY(random(12) + deg);
      }
    }
  }

  @for $i from 1 through $itemsCount {
    $zIndexStartValue: $itemsCount + 1; // we don't want an item with 0 index
    $xValue: ($i - 1) * 10px; // we want to start translating from 0
    $yValue: ($i - 1) * 10px; // we want to start translating from 0
    $zIndexValue: $itemsCount -
      $i; // reverse the z-index, so first item is on top

    &:nth-of-type(#{$i}) {
      z-index: $zIndexValue;
      transform: translateX(#{$xValue}) translateY(#{$yValue});
    }
  }
}

// Cards

@media (min-width: 480px) {
  .cards-container {
    position: relative;
    z-index: 1;
    margin: 0 auto;
  }

  .card {
    position: absolute;
    background-color: gold;
    border: 1px solid #423e37;
    box-shadow: 9px 11px 3px 0px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 40px;
    transition: transform 0.3s, opacity 0.2s;

    &.hidden {
      z-index: 100;
      background-color: #fff;
      color: #fff;
      opacity: 0;
      transition: color 0.5s, background-color 0.5s, transform 1s,
        opacity 0.2s 0.4s;

      h1 {
        color: #fff;
        transition: color 0.5s;
      }

      p {
        font-size: 18px;
      }

      @for $i from 1 through $itemsCount {
        &:nth-of-type(#{$i}) {
          transform: rotate(random(100) - 100 + deg)
            translateX((random(1) + 100) * 1%)
            translateY(random(60) * -1%)
            scale(random(10) * 0.1)
            skewX(random(12) + deg)
            skewY(random(12) + deg);
        }
      }
    }

    @for $i from 1 through $itemsCount {
      $zIndexStartValue: $itemsCount + 1; // we don't want an item with 0 index
      $xValue: ($i - 1) * 10px; // we want to start translating from 0
      $yValue: ($i - 1) * 10px; // we want to start translating from 0
      $zIndexValue: $itemsCount -
        $i; // reverse the z-index, so first item is on top

      &:nth-of-type(#{$i}) {
        z-index: $zIndexValue;
        transform: translateX(#{$xValue}) translateY(#{$yValue});
      }
    }
  }
}

@media (min-width: 960px) {
  .cards-container {
    position: relative;
    z-index: 1;
    width: 650px;
    height: 400px;
    margin: 0 auto;
  }

  .card {
    position: absolute;
    width: 600px;
    height: 300px;
    background-color: gold;
    box-shadow: 9px 11px 3px 0px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 40px;
    transition: transform 0.3s, opacity 0.2s;

    &.hidden {
      z-index: 100;
      background-color: #fff;
      color: #fff;
      opacity: 0;
      transition: color 0.5s, background-color 0.5s, transform 1s,
        opacity 0.2s 0.4s;

      h1 {
        color: #fff;
        transition: color 0.5s;
      }

      @for $i from 1 through $itemsCount {
        &:nth-of-type(#{$i}) {
          transform: rotate(random(100) - 100 + deg)
            translateX((random(1) + 100) * 1%)
            translateY(random(60) * -1%)
            scale(random(10) * 0.1)
            skewX(random(12) + deg)
            skewY(random(12) + deg);
        }
      }
    }

    @for $i from 1 through $itemsCount {
      $zIndexStartValue: $itemsCount + 1; // we don't want an item with 0 index
      $xValue: ($i - 1) * 10px; // we want to start translating from 0
      $yValue: ($i - 1) * 10px; // we want to start translating from 0
      $zIndexValue: $itemsCount -
        $i; // reverse the z-index, so first item is on top

      &:nth-of-type(#{$i}) {
        z-index: $zIndexValue;
        transform: translateX(#{$xValue}) translateY(#{$yValue});
      }
    }
  }
}

@media (min-width: 1025px) {
  .cards-container {
    position: relative;
    z-index: 1;
    width: 750px;
    height: 400px;
    margin: 0 auto;
  }

  .card {
    position: absolute;
    width: 700px;
    height: 300px;
    background-color: gold;
    border: 1px solid #423e37;
    box-shadow: 9px 11px 3px 0px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    padding: 40px;

    transition: transform 0.3s, opacity 0.2s;

    &.hidden {
      z-index: 100;
      background-color: #fff;
      color: #fff;
      opacity: 0;

      transition: color 0.5s, background-color 0.5s, transform 1s,
        opacity 0.2s 0.4s;

      h1 {
        color: #fff;

        transition: color 0.5s;
      }

      @for $i from 1 through $itemsCount {
        &:nth-of-type(#{$i}) {
          transform: rotate(random(100) - 100 + deg)
            translateX((random(1) + 100) * 1%)
            translateY(random(60) * -1%)
            scale(random(10) * 0.1)
            skewX(random(12) + deg)
            skewY(random(12) + deg);
        }
      }
    }

    @for $i from 1 through $itemsCount {
      $zIndexStartValue: $itemsCount + 1; // we don't want an item with 0 index
      $xValue: ($i - 1) * 10px; // we want to start translating from 0
      $yValue: ($i - 1) * 10px; // we want to start translating from 0
      $zIndexValue: $itemsCount -
        $i; // reverse the z-index, so first item is on top

      &:nth-of-type(#{$i}) {
        z-index: $zIndexValue;
        transform: translateX(#{$xValue}) translateY(#{$yValue});
      }
    }
  }
}

@media (min-width: 1200px) {
  .smk_responsive {
    zoom: 0.9;
    // transform: scale(0.5);
  }
}

@media (min-width: 1000px) AND (max-width: 1200px) {
  .smk_responsive {
    zoom: 0.8;
    // transform: scale(0.5);
  }
}

@media (min-width: 800px) AND (max-width: 1000px) {
  .smk_responsive {
    zoom: 0.6;
    // transform: scale(0.5);
  }
}

@media (min-width: 600px) AND (max-width: 800px) {
  .smk_responsive {
    zoom: 0.5;
    // transform: scale(0.5);
  }
}

@media (min-width: 500px) AND (max-width: 600px) {
  .smk_responsive {
    zoom: 0.4;
    // transform: scale(0.5);
  }
}

@media (max-width: 500px) {
  .smk_responsive {
    zoom: 0.3;
    // transform: scale(0.5);
  }
}

@media (min-width: 1200px) {
  .smk_responsive2 {
    zoom: 1;
    // transform: scale(0.5);
  }
}

@media (min-width: 1000px) AND (max-width: 1200px) {
  .smk_responsive2 {
    zoom: 0.9;
    // transform: scale(0.5);
  }
}

@media (min-width: 800px) AND (max-width: 1000px) {
  .smk_responsive2 {
    zoom: 0.8;
    // transform: scale(0.5);
  }
}

@media (min-width: 600px) AND (max-width: 800px) {
  .smk_responsive2 {
    zoom: 0.7;
    // transform: scale(0.5);
  }
}

@media (min-width: 500px) AND (max-width: 600px) {
  .smk_responsive2 {
    zoom: 0.6;
    // transform: scale(0.5);
  }
}

@media (max-width: 500px) {
  .smk_responsive2 {
    zoom: 0.5;
    // transform: scale(0.5);
  }
}

@media (min-width: 1200px) {
  .smk_responsive3 {
    zoom: 1;
    // transform: scale(0.5);
  }
}

@media (min-width: 1000px) AND (max-width: 1200px) {
  .smk_responsive3 {
    zoom: 0.8;
    // transform: scale(0.5);
  }
}

@media (min-width: 800px) AND (max-width: 1000px) {
  .smk_responsive3 {
    zoom: 0.7;
    // transform: scale(0.5);
  }
}

@media (min-width: 600px) AND (max-width: 800px) {
  .smk_responsive3 {
    zoom: 0.6;
    // transform: scale(0.5);
  }
}

@media (min-width: 500px) AND (max-width: 600px) {
  .smk_responsive3 {
    zoom: 0.5;
    // transform: scale(0.5);
  }
}

@media (max-width: 500px) {
  .smk_responsive3 {
    zoom: 0.4;
    // transform: scale(0.5);
  }
}
</style>
